import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { TERMS_MD } from "@/lib/terms";
import { TermsMarkdown } from "@/components/TermsMarkdown";

export default function Terms() {
  return (
    <div className="min-h-screen bg-background" data-testid="terms-page">
      <div className="mx-auto max-w-3xl px-5 py-12 sm:px-8 lg:py-16">
        <Link
          to="/"
          className="mb-8 inline-flex items-center gap-1.5 text-sm font-medium text-muted-foreground transition-colors hover:text-foreground"
          data-testid="terms-back-link"
        >
          <ArrowLeft className="h-4 w-4" /> Back to home
        </Link>
        <article>
          <TermsMarkdown source={TERMS_MD} />
        </article>
      </div>
    </div>
  );
}
